import React, { useContext, useEffect, useState } from "react";
import Utils from "../../../Utils";
import { Dropdown, FormControl, Tab, Tabs } from "react-bootstrap";
import IncompleteReport from "../sites/site/report/IncompleteReport";
import AllReportsPage from "../sites/site/report/AllReportsPage";
import ContextComponent from "../../../AppContext";
import { utility } from "../sites/site/report/utility";

const SectionReportsPage = () => {
  const { setLoadingState } = useContext(ContextComponent);
  const [activeTab, setActiveTab] = useState("incomplete");
  const [siteName, setSiteName] = useState("");
  const [currSiteId, setCurrSiteId] = useState(null);
  const [search, setSearch] = useState("");
  const [siteOptions, setSiteOptions] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [selectedSite, setSelectedSite] = useState("");

  const tableColumns = utility.tableColumns;
  const tableColumnSchema = utility.tableColumnSchema;

  useEffect(() => {
    loadSites();
  }, []);

  const loadSites = () => {
    const success = (res) => {
      setLoadingState({ applyMask: false });
      const sortedSites = res.data.sort((a, b) => a.name.localeCompare(b.name));
      setSiteOptions(sortedSites);
      setFilteredOptions(sortedSites);

      if (sortedSites.length > 0) {
        setCurrSiteId(sortedSites[0].id);
        setSelectedSite(sortedSites[0].name);
        setSiteName(sortedSites[0].name);
      }
    };

    const fail = (err) => {
      setLoadingState({ applyMask: false });
      console.error("Error fetching sites:", err);
    };

    setLoadingState({ applyMask: true, text: "Loading sites" });
    Utils.getAllSitesForReport().then(success, fail);
  };

  const handleDownload = () => {
    const reportType = activeTab === "incomplete" ? "incomplete" : "complete";
    exportReports(currSiteId, reportType);
  };

  const exportReports = (currSiteId, reportType) => {
    Utils.getExportReportsBySiteId({ siteId: currSiteId, reportType })
      .then((res) => {
        success(res, reportType);
      })
      .catch((error) => {
        console.error("Download failed", error);
      });
  };

  const success = (res, reportType) => {
    // Assuming res contains the CSV data as text
    const csvData = res.data;
    const fileName = `${siteName.replace(
      /[()]/g,
      ""
    )}-${reportType}-${new Date()
      .toISOString()
      .replace(/:/g, "-")
      .replace(/\./g, "-")}.csv`;

    // Create a BOM (Byte Order Mark) for UTF-8 encoding
    const BOM = "\uFEFF"; // UTF-8 BOM

    // Concatenate the BOM and the CSV data
    const csvWithBOM = BOM + csvData;
    const blob = new Blob([csvWithBOM], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
    setFilteredOptions(
      siteOptions.filter((site) =>
        site.name.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  const handleSelect = (site) => {
    setSelectedSite(site.name);
    setSiteName(site.name);
    setCurrSiteId(site.id);
    setSearch("");
    setFilteredOptions(siteOptions);
  };

  const handleClearSearch = (e) => {
    setSearch("");
    setFilteredOptions(siteOptions);
  };

  return (
    <>
      <div className="indi-site-reports-wrapper">
        <div className="indi-site-reports-header-wrapper">
          <div className="indi-site-reports-dropdown-wrapper">
            <Dropdown className="indi-site-reports-dropdown">
              <span className="indi-site-reports-dropdown-prefix-text">
                Select a site
              </span>
              <Dropdown.Toggle title={selectedSite}>
                {selectedSite || "Select a site"}
              </Dropdown.Toggle>
              <Dropdown.Menu className="indi-site-reports-dropdown-menu">
                <div className="indi-site-reports-dropdown-search">
                  <FormControl
                    autoFocus
                    placeholder="Search..."
                    value={search}
                    onChange={handleSearch}
                  />
                  <button onClick={handleClearSearch}>x</button>
                </div>
                <Dropdown.Divider className="indi-site-reports-dropdown-menu-seperator" />
                <div className="indi-site-reports-dropdown-list">
                  {filteredOptions.length > 0 ? (
                    filteredOptions.map((site) => (
                      <Dropdown.Item
                        key={site.id}
                        title={site.name}
                        onClick={() => handleSelect(site)}
                      >
                        {site.name}
                      </Dropdown.Item>
                    ))
                  ) : (
                    <Dropdown.Item disabled>No results found</Dropdown.Item>
                  )}
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="indi-site-reports-header">
            <div className="indi-site-reports-title-text" title={siteName}>
              Reports ({siteName})
            </div>

            <div
              className="indi-site-reports-action"
              role="button"
              onClick={handleDownload}
            >
              Export to Excel
            </div>
          </div>
        </div>

        {/* TAB view */}
        <div className="indi-site-reports-form-wrapper">
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="mb-3"
          >
            <Tab
              eventKey="incomplete"
              title={<span className="indi-tab-title">Incomplete</span>}
            >
              {currSiteId && (
                <IncompleteReport
                  props={{
                    siteId: currSiteId,
                    tableColumns,
                    tableColumnSchema,
                    setLoadingState,
                  }}
                />
              )}
            </Tab>
            <Tab
              eventKey="complete"
              title={<span className="indi-tab-title">Complete</span>}
            >
              {currSiteId && (
                <AllReportsPage
                  props={{
                    siteId: currSiteId,
                    tableColumns,
                    tableColumnSchema,
                    setLoadingState,
                  }}
                />
              )}
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default SectionReportsPage;
